import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useSelector, useDispatch } from "react-redux";
import { setUnlock, setImage } from "../../../store/slices/kamasutra";

import KamaCard from "../gameCard";
import CustomModal from "../../modal";

import styles from "./kamaModalUnlock.module.css";

export default function KamaListUnlock() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { image, hotLevel, number, unlock } = useSelector(
    (state) => state.kamasutra
  );

  const [revealed, setRevealed] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (unlock) {
      setTimeout(() => {
        setRevealed(true);
        setTimeout(() => {
          setShow(true);
        }, 1000);
      }, 500);
    }
  }, [unlock]);

  const handleClose = () => {
    dispatch(setUnlock(false));
  };

  const handleAfterClose = () => {
    dispatch(setImage(""));
    setShow(false);
    setRevealed(false);
  };

  return (
    <CustomModal
      visible={unlock}
      handleClose={handleClose}
      handleAfterClose={handleAfterClose}
      className="flex-1 flex flex-col justify-center items-center"
    >
      <KamaCard
        image={image}
        hotLevel={hotLevel}
        number={number}
        className={`${styles.card} ${revealed ? styles.revealed : ""}`}
        borderSize={25}
        Back={() => {
          return (
            <div className={styles.number}>
              <h2>{number}</h2>
            </div>
          );
        }}
      />
      <div className={`${styles.footer} ${show ? styles.show : ""}`}>
        <button
          type="button"
          onClick={handleClose}
          className="btn btn-brand btn-small w-full"
        >
          {t("close")}
        </button>
      </div>
    </CustomModal>
  );
}
